const name = 'stack-tabs__panel__vps';
const radioClass = 'custom-radio';
const radioGroupClass = 'custom-radio-group';
const radioInputClass = 'custom-radio__control';

const vps = () => {
  const panel = document.getElementById(name);

  if (panel != null) {
      panel.addEventListener('change', ({ target} = e) => {
        if (!target.classList.contains(radioInputClass)) { return }

        const { nb } = target.dataset;

        panel.querySelectorAll(`.${radioGroupClass}`).forEach(e => {
          (e.querySelector(`[data-nb="${nb}"]`) || e.querySelector(`.${radioClass}:last-child input`)).click();
        })
      })
  }
};

export default vps;
